import { useMutation } from '@tanstack/react-query'

import { saveSurvey } from '../api'

const useSaveSurvey = () => {
  return useMutation({
    mutationKey: ['saveSurvey'],
    mutationFn: saveSurvey,
  })
}

export default useSaveSurvey
